"use strict";

var _slicedToArray = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IMAGE_KEY = Symbol["for"]("image");
/**
 * Converts the new Attheme instance into the old one compatible with the old
 * versions of attheme-js.
 * @param theme The new Attheme instance.
 * @returns An object compatible with the old versions of attheme-js.
 */

var themeToObject = function themeToObject(theme) {
  var object = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = theme[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var variable = _ref2[0];
      var value = _ref2[1];

      if (variable === "__proto__") {
        continue;
      }

      object[variable] = value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (theme.hasWallpaper()) {
    object[IMAGE_KEY] = theme.getWallpaper();
  }

  return object;
};

exports["default"] = themeToObject;